exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sub-text-label[data-v-f742c968] {\n  font-size: 0.85em;\n}\n.icon-container[data-v-f742c968] {\n  padding-top: 5px;\n}\n.template-name-label[data-v-f742c968] {\n  -ms-word-wrap: break-word;\n  overflow-wrap: break-word;\n  display: block;\n  font-weight: bold;\n}\n", ""]);

